/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Pub_Need_EvidenceInputs */

const en_fw_pub_need_evidence = /** @type {(inputs: Fw_Pub_Need_EvidenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verify at least 5 tasks in this plan before publishing it as a template.`)
};

const id_fw_pub_need_evidence = /** @type {(inputs: Fw_Pub_Need_EvidenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifikasi minimal 5 task di rencana ini sebelum menerbitkannya jadi template.`)
};

/**
* | output |
* | --- |
* | "Verify at least 5 tasks in this plan before publishing it as a template." |
*
* @param {Fw_Pub_Need_EvidenceInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_pub_need_evidence = /** @type {((inputs?: Fw_Pub_Need_EvidenceInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Pub_Need_EvidenceInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_pub_need_evidence(inputs)
	return en_fw_pub_need_evidence(inputs)
});